import * as hash from 'object-hash';
import { IAntibodyScreening, IAntibodyScreeningResult } from '@nkr/models/index';

interface IState {
    hash: string,
    data: IAntibodyScreening[],
    details: {
        show: boolean,
        data: IAntibodyScreeningResult[]
    }
}

const initialState: IState = {
    hash: '',
    data: [],
    details: {
        show: false,
        data: null
    }
};

const antibodyScreeningsReducer = (state: IState, action): IState => {
    if (action.type == 'afterLoad') {
        return {
            ...state,
            data: action.value.data,
            hash: hash(action.value.data),
        };
    }

    if (action.type == 'updateHash') {
        return { ...state, hash: action.value };
    }

    if (action.type == 'updateData') {
        return { ...state, data: action.value };
    }

    if (action.type == 'updateDetails') {
        return { ...state, details: action.value };
    }

    return { ...state };
};


export { IState, initialState, antibodyScreeningsReducer };